import React from 'react'
import iconBirthday from 'assets/images/icon-birthday-cake.svg';
import iconVIP from 'assets/images/icon-vip.svg';
import UserGuestIcon from 'common/customIcons/user_guest';
import { Icon } from '@mui/material';

export function NewMember() {
    return (
        <badge className="font-weight-600 text-white-900 d-flex align-item-center justify-content-center new-badge">
            NEW
        </badge>
    )
}
export function VipMember() {
    return (
        <badge className="font-weight-600 text-white-900 d-flex align-item-center justify-content-center vip-badge">
            <img src={iconVIP} />
            VIP
        </badge>
    )
}
export function MemberBirthday() {
    return (
        <badge className="birthday-badge">
            <img src={iconBirthday} />
        </badge>
    )
}

export function Memberguest() {
    return (
        <badge className="birthday-badge">
            <Icon fontSize="small" color='success'>
            <UserGuestIcon width="20px" height="20px" />
            </Icon>
        </badge>
    )
}